// This file is auto-generated by @hey-api/openapi-ts

/**
 * Type of order item.
 */
export const OrderItemTypesEnum = {
    FEE: 'FEE',
    PRODUCT: 'PRODUCT',
    TICKET_FARE: 'TICKET_FARE',
    PAK_TICKET_FARE: 'PAK_TICKET_FARE',
    ELECTRONIC_WALLET: 'ELECTRONIC_WALLET',
    RECLAMATION: 'RECLAMATION',
    ROUNDING: 'ROUNDING',
    OFFENSE: 'OFFENSE'
} as const;

/**
 * Type of order item.
 */
export type OrderItemTypesEnum = typeof OrderItemTypesEnum[keyof typeof OrderItemTypesEnum];
